import { Flex, MenuProps } from "antd";
import { observer } from "mobx-react-lite";
import { CustomButton, DropdownButton } from "ui";
import { ReactComponent as MoreIcon } from "images/ellipses.svg";
import { BID_REQUEST_STATUS_ENUM, QUOTE_STATUS_ENUM, QuoteEntity } from "interfaces";
import { downloadFileBlob, isStatusIncluded, useRequestWithNotify } from "utils";

import { useStores } from "stores";
import { ConfirmationModal, confirmationModalConfigs } from "components/ActionModals/ConfirmationModal";
import { cancelQuote, ENDPOINTS } from "services";

import { QuoteExtendModal } from "../QuoteExtendBtn/QuoteExtendModal";
import { CancelQuoteButton } from "../CancelQuote";
import { QuoteExtendBtn } from "../QuoteExtendBtn";

export const QuoteActionBtn = observer(({ quote }: { quote: QuoteEntity }) => {
  const { quotes, bidCard, actionModals, user } = useStores();
  const { isRiskManager, isSeniorLP } = user.roles;

  const isSeniorLPExp = isSeniorLP && bidCard.bid.contract.direction === "EXP";
  const isSeniorLPImp = isSeniorLP && bidCard.bid.contract.direction === "IMP";

  const showRemoveQuoteButton =
    isSeniorLP &&
    isStatusIncluded(bidCard.bid.status, [BID_REQUEST_STATUS_ENUM.NEW, BID_REQUEST_STATUS_ENUM.QUOTE_PROPOSED]) &&
    isStatusIncluded(quote.status, [QUOTE_STATUS_ENUM.CREATED, QUOTE_STATUS_ENUM.OFFERED]);

  const hasExpTime = !!quote.quoteExpTime;
  const isBidStatus = isStatusIncluded(bidCard.bid.status, [
    BID_REQUEST_STATUS_ENUM.NEW,
    BID_REQUEST_STATUS_ENUM.QUOTE_PROPOSED,
  ]);
  const isSeniorWithValidStatus = (isSeniorLPExp || isSeniorLPImp) && isBidStatus;
  const isQuoteStatus =
    quote.status === QUOTE_STATUS_ENUM.CREATED ||
    quote.status === QUOTE_STATUS_ENUM.OFFERED ||
    (quote.status === QUOTE_STATUS_ENUM.ACCEPTED && isSeniorLPExp);

  const showQuoteExtendBtn = hasExpTime && isSeniorWithValidStatus && isQuoteStatus;

  return (
    <Flex>
      {showQuoteExtendBtn && <QuoteExtendBtn quoteExpTime={quote.quoteExpTime ?? ""} id={quote.id} />}
      {showRemoveQuoteButton && <CancelQuoteButton id={quote.id} />}
    </Flex>
  );
});
